import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'take'})
export class TakePipe implements PipeTransform {
    transform(input: any[], take: number): any {
        return input.slice(0, take);
    }
}
